/* =====================================================================
   MOMENTUM — core theme behaviour. Vanilla JS, no dependencies.
   ===================================================================== */
(function () {
  'use strict';

  var CFG = window.MOMENTUM || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* -------- money -------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, val)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }
  window.MOMENTUM_formatMoney = formatMoney;

  /* -------- header scroll -------- */
  function header() {
    var h = $('.site-header');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------- mobile nav -------- */
  function mobileNav() {
    var burger = $('.hamburger');
    var nav = $('.mobile-nav');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* -------- scroll reveal -------- */
  function reveal() {
    var els = $$('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -------- countdowns -------- */
  function countdowns() {
    var targets = $$('[data-countdown]');
    if (!targets.length) return;
    var date = new Date((CFG.dropDate || '2026-09-01T20:00').replace(' ', 'T'));
    function tick() {
      var diff = Math.max(0, date - new Date());
      var d = Math.floor(diff / 864e5);
      var h = Math.floor(diff % 864e5 / 36e5);
      var m = Math.floor(diff % 36e5 / 6e4);
      var s = Math.floor(diff % 6e4 / 1e3);
      targets.forEach(function (root) {
        var set = function (k, v) { var el = $('[data-cd="' + k + '"]', root); if (el) el.textContent = String(v).padStart(2, '0'); };
        set('days', d); set('hours', h); set('minutes', m); set('seconds', s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* -------- toast -------- */
  function toast(title, sub) {
    var host = $('#ToastHost');
    if (!host) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = '<span class="dot"></span><span class="t-txt">' + title + (sub ? '<small>' + sub + '</small>' : '') + '</span>';
    host.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-show'); });
    setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.remove(); }, 450);
    }, 2800);
  }
  window.MOMENTUM_toast = toast;

  /* ===================== CART ===================== */
  var Cart = {
    open: function () { var d = $('.cart-drawer'); if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; } },
    close: function () { var d = $('.cart-drawer'); if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; } },

    refresh: function () {
      return fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) Cart.render(cart); return cart; })
        .catch(function () { return null; });
    },

    render: function (cart) {
      // count badge
      $$('.cart-count').forEach(function (b) {
        b.textContent = cart.item_count;
        b.hidden = cart.item_count === 0;
      });
      var list = $('#CartItems');
      if (!list) return;
      if (cart.item_count === 0) {
        list.innerHTML = '<div class="cart-empty">// CART EMPTY //<br>No gear queued.</div>';
      } else {
        list.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
          return '<div class="cart-item" data-key="' + item.key + '">' +
            '<div class="cart-item__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div>' +
              '<div class="cart-item__title">' + item.product_title + '</div>' +
              (variant ? '<div class="cart-item__variant">' + variant + '</div>' : '') +
              '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
              '<button class="cart-item__remove" data-remove="' + item.key + '">Remove</button>' +
            '</div>' +
            '<div class="qty" data-key="' + item.key + '">' +
              '<button data-qchg="-1" aria-label="Decrease">−</button>' +
              '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qval readonly>' +
              '<button data-qchg="1" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>';
        }).join('');
      }
      var sub = $('#CartSubtotal');
      if (sub) sub.textContent = formatMoney(cart.total_price);
      var checkoutBtn = $('#CartCheckout');
      if (checkoutBtn) checkoutBtn.toggleAttribute('disabled', cart.item_count === 0);
    },

    add: function (form) {
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'ADDING…'; btn.disabled = true; }
      var data = new FormData(form);
      return fetch(CFG.routes.cart_add, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      }).then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { // error
            toast('UNAVAILABLE', res.description || 'Could not add');
          } else {
            toast('ADDED TO CART', res.product_title || res.title);
            return Cart.refresh().then(function () { Cart.open(); });
          }
        })
        .catch(function () { toast('ERROR', 'Network issue'); })
        .finally(function () { if (btn) { btn.textContent = original; btn.disabled = false; } });
    },

    change: function (key, qty) {
      return fetch(CFG.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); return cart; });
    }
  };
  window.MOMENTUM_Cart = Cart;

  function cartBindings() {
    // open/close
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn && (CFG.cartType !== 'page')) {
        // only intercept if drawer exists
        if ($('.cart-drawer')) { e.preventDefault(); Cart.open(); }
      }
      if (e.target.closest('[data-cart-close]')) { Cart.close(); }
      var rm = e.target.closest('[data-remove]');
      if (rm) { Cart.change(rm.getAttribute('data-remove'), 0); }
      var qchg = e.target.closest('[data-qchg]');
      if (qchg) {
        var row = qchg.closest('.qty');
        var key = row && row.getAttribute('data-key');
        if (key) {
          var input = $('[data-qval]', row);
          var next = Math.max(0, parseInt(input.value, 10) + parseInt(qchg.getAttribute('data-qchg'), 10));
          Cart.change(key, next);
        }
      }
    });

    // add-to-cart forms (product + quick add)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"], form[data-cart-add]');
      if (form) { e.preventDefault(); Cart.add(form); }
    });

    // discount apply (visual only — Shopify applies at checkout)
    var dForm = $('#DiscountForm');
    if (dForm) {
      dForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = $('input', dForm).value.trim();
        if (code) { toast('CODE QUEUED', code.toUpperCase() + ' applies at checkout'); }
      });
    }

    Cart.refresh();
  }

  /* ===================== PRODUCT PAGE ===================== */
  function productPage() {
    var root = $('[data-product-root]');
    if (!root) return;

    // gallery
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-thumb');
        var main = $('[data-media-main]', root);
        if (main) main.src = src;
        $$('[data-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // quantity
    $$('.qty', root).forEach(function (q) {
      var input = $('[data-qval], input', q);
      $$('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.getAttribute('data-qchg') === '-1' || b.textContent.trim() === '−' ? -1 : 1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
        });
      });
    });

    // variant selection -> update price, image, availability, hidden id
    var variantData = window.__MOMENTUM_VARIANTS;
    if (variantData) {
      var optionInputs = $$('input[data-opt]', root);
      function currentOptions() {
        var opts = [];
        var groups = {};
        optionInputs.forEach(function (i) {
          if (i.checked) groups[i.getAttribute('data-opt-index')] = i.value;
        });
        Object.keys(groups).sort().forEach(function (k) { opts.push(groups[k]); });
        return opts;
      }
      function update() {
        var opts = currentOptions();
        var match = variantData.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        var idField = $('[data-variant-id]', root);
        var priceEl = $('[data-product-price]', root);
        var atc = $('[data-atc]', root);
        if (match) {
          if (idField) idField.value = match.id;
          if (priceEl) priceEl.innerHTML = (match.compare_at_price && match.compare_at_price > match.price ? '<s>' + formatMoney(match.compare_at_price) + '</s>' : '') + formatMoney(match.price);
          if (atc) {
            atc.disabled = !match.available;
            atc.textContent = match.available ? 'Add to Cart' : 'Sold Out';
          }
          var saPrice = $('.sa-price'); if (saPrice) saPrice.textContent = formatMoney(match.price);
          if (match.featured_image && match.featured_image.src) {
            var main = $('[data-media-main]', root);
            if (main) main.src = match.featured_image.src;
          }
        } else if (atc) {
          atc.disabled = true; atc.textContent = 'Unavailable';
        }
      }
      optionInputs.forEach(function (i) { i.addEventListener('change', update); });
      update();
    }

    // sticky mobile ATC
    var sticky = $('.sticky-atc');
    var atcArea = $('[data-atc-area]');
    if (sticky && atcArea && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.innerWidth <= 900);
      }, { threshold: 0 });
      io.observe(atcArea);
      var sb = $('[data-sticky-atc]', sticky);
      if (sb) sb.addEventListener('click', function () {
        var form = $('form[action*="/cart/add"]', root);
        if (form) Cart.add(form);
      });
    }
  }

  /* ===================== COLLECTION FILTERS ===================== */
  function collectionFilters() {
    var root = $('[data-collection-root]');
    if (!root) return;
    var cards = $$('[data-pcard]', root);

    function applyFilters() {
      var activeTypes = $$('[data-filter="type"]:checked', root).map(function (i) { return i.value; });
      var activeVendors = $$('[data-filter="vendor"]:checked', root).map(function (i) { return i.value; });
      var avail = $$('[data-filter="availability"]:checked', root).map(function (i) { return i.value; });
      var minEl = $('[data-price-min]', root), maxEl = $('[data-price-max]', root);
      var min = minEl && minEl.value ? parseFloat(minEl.value) * 100 : 0;
      var max = maxEl && maxEl.value ? parseFloat(maxEl.value) * 100 : Infinity;
      var activeTab = $('.cat-tab.is-active', root);
      var tab = activeTab ? activeTab.getAttribute('data-tab') : 'all';
      var shown = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (activeTypes.length && activeTypes.indexOf(c.getAttribute('data-type')) === -1) ok = false;
        if (activeVendors.length && activeVendors.indexOf(c.getAttribute('data-vendor')) === -1) ok = false;
        if (avail.length) {
          var isAvail = c.getAttribute('data-available') === 'true';
          if (avail.indexOf('in') > -1 && !isAvail) ok = false;
          if (avail.indexOf('in') === -1 && isAvail && avail.indexOf('out') > -1) { /* only out wanted */ if(isAvail) ok=false; }
        }
        var price = parseInt(c.getAttribute('data-price'), 10) || 0;
        if (price < min || price > max) ok = false;
        if (tab !== 'all' && (c.getAttribute('data-tags') || '').indexOf(tab) === -1) ok = false;
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      var rc = $('[data-result-count]', root);
      if (rc) rc.textContent = shown + ' STYLES';
      var empty = $('[data-filter-empty]', root);
      if (empty) empty.hidden = shown !== 0;
    }

    $$('[data-filter], [data-price-min], [data-price-max]', root).forEach(function (i) {
      i.addEventListener('change', applyFilters);
      i.addEventListener('input', applyFilters);
    });
    $$('.cat-tab', root).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.cat-tab', root).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        applyFilters();
      });
    });
    // sort
    var sort = $('[data-sort]', root);
    if (sort) {
      sort.addEventListener('change', function () {
        var grid = $('[data-product-grid]', root);
        var arr = $$('[data-pcard]', root);
        arr.sort(function (a, b) {
          var pa = parseInt(a.getAttribute('data-price'), 10), pb = parseInt(b.getAttribute('data-price'), 10);
          if (sort.value === 'price-asc') return pa - pb;
          if (sort.value === 'price-desc') return pb - pa;
          if (sort.value === 'title') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
          return 0;
        });
        arr.forEach(function (c) { grid.appendChild(c); });
      });
    }
    // mobile filter toggle
    var toggle = $('[data-filter-toggle]');
    var panel = $('.filters', root);
    if (toggle && panel) {
      toggle.addEventListener('click', function () { panel.classList.toggle('is-open'); });
      var fc = $('[data-filter-done]', panel);
      if (fc) fc.addEventListener('click', function () { panel.classList.remove('is-open'); });
    }
  }

  /* ===================== VAULT ===================== */
  function vault() {
    var form = $('#VaultForm');
    if (!form) return;
    var revealed = sessionStorage.getItem('momentum_vault') === '1';
    if (revealed) showVault();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input', form);
      var err = $('.vault-error');
      var pw = (CFG.vaultPassword || 'GHOST').toString().toUpperCase();
      if (input.value.trim().toUpperCase() === pw) {
        sessionStorage.setItem('momentum_vault', '1');
        showVault();
      } else {
        if (err) err.textContent = '// ACCESS DENIED — INVALID KEY';
        form.classList.add('shake');
        setTimeout(function () { form.classList.remove('shake'); }, 400);
      }
    });
    function showVault() {
      var lock = $('[data-vault-lock]'); var content = $('[data-vault-content]');
      if (lock) lock.hidden = true;
      if (content) content.hidden = false;
    }
  }

  /* ===================== FILM / play buttons (no real video) ===================== */
  function filmButtons() {
    $$('[data-play]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-play');
        if (v) window.open(v, '_blank');
        else toast('FILM', 'Trailer drops with the collection');
      });
    });
  }

  /* -------- boot -------- */
  function init() {
    header();
    mobileNav();
    reveal();
    countdowns();
    cartBindings();
    productPage();
    collectionFilters();
    vault();
    filmButtons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
